module.exports = __webpack_public_path__ + "img/04.b4ba3a8f.png";